import { Component, OnInit } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {DataProvider} from "../../providers/data/data";
import {HomePage} from "../home/home";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {OrdersPage} from "../orders/orders";

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage implements OnInit {

  public loading = true;

  constructor(public navCtrl: NavController, public navParams: NavParams, public data: DataProvider, public http: HttpClient) {
  }

  ngOnInit() {
  }

  ionViewDidLoad() {
    this.user_load();
  }

  user_load() {
    const body = {
      token: localStorage.getItem('token'),
      module: 'users',
      submodule: 'load'
    };
    this.http.post(environment.api_url, body).subscribe(resp => {
        this.loading = false;
        if (resp['data'] !== null) {
          if (resp['data'].name !== undefined) {
            this.data.user = resp['data'].name;
            this.data.role = resp['data'].role;
            this.navCtrl.setRoot(OrdersPage);
          }
        }
      }, error => {
        alert('keine Verbindung zum Server möglich');
      }
    );
  }

  user_login(username, password) {
    const body = {
      token: localStorage.getItem('token'),
      module: 'users',
      submodule: 'login',
      username: username.value,
      pass: password.value
    };
    this.http.post(environment.api_url, body).subscribe(resp => {
        if (resp['data'].token !== undefined) {
          localStorage.setItem('token', resp['data']['token']);
          this.data.user = resp['data'].user.name;
          this.data.role = resp['data'].user.role;
          this.navCtrl.setRoot(OrdersPage);
        } else {
          alert(resp['message']);
        }
      }, error => {
        alert('keine Verbindung zum Server möglich');
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts